import { useEffect, useMemo, useState } from "react";

function safeParseJson(str) {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}

export function usePersistedPagination(storageKey, { defaultPage = 1, defaultLimit = 10 } = {}) {
  const key = useMemo(() => `pagination:${storageKey}`, [storageKey]);

  const [page, setPage] = useState(() => {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(key) : null;
    const parsed = raw ? safeParseJson(raw) : null;
    const p = parseInt(parsed?.page, 10);
    return Number.isFinite(p) && p > 0 ? p : defaultPage;
  });

  const [limit, setLimit] = useState(() => {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(key) : null;
    const parsed = raw ? safeParseJson(raw) : null;
    const l = parseInt(parsed?.limit, 10);
    return Number.isFinite(l) && l > 0 ? l : defaultLimit;
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify({ page, limit }));
    } catch {
      // ignore storage errors
    }
  }, [key, page, limit]);

  const reset = () => {
    setPage(defaultPage);
    setLimit(defaultLimit);
  };

  return { page, setPage, limit, setLimit, reset };
}

